// extracted by mini-css-extract-plugin
export default {"container":"Checkbox_container__BWOFX","inputWrapper":"Checkbox_inputWrapper__floxM","input":"Checkbox_input__eVCgi","check":"Checkbox_check__7spEK","text":"Checkbox_text__UPb1o"};